import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Spinner from '@atlaskit/spinner';

import { i18n } from '../contentByLabelMacroI18n.ts';

const styles = cssMap({
	container: {
		minHeight: 'auto',
		paddingBlock: token('space.150'),
		paddingInline: token('space.150'),
	},
});

export const LoadingState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container} testId="content-by-label-loading">
			<Stack alignInline="center" space="space.100">
				<Spinner size="medium" label={formatMessage(i18n.loading)} />
			</Stack>
		</Box>
	);
};
